<template>
  <el-dialog
    :visible.sync="visible"
    width="800px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :z-index="4000"
    append-to-body
    class="pledge-dialog"
    @close="handleClose"
  >
    <div class="pledge-container">
      <div class="pledge-title">四川省高等教育自学考试综合评价诚信学习承诺书</div>
      <div class="pledge-sheet">
        <div class="pledge-body">
          <!-- <div class="pledge-body__title">四川省高等教育自学考试网络助学综合评价考核诚信学习承诺书</div> -->
          <!-- <p>
            我承诺在毕业论文（设计）工作中遵守学校有关规定，恪守学术规范，本人毕业论文（设计）内容除特别注明和引用外，均为本人观点，不存在剽窃、抄袭他人学术成果、伪造、篡改实验数据的情况。如有违规行为，我愿承担一切责任，接受学校的处理。
          </p> -->
          <div class="promiseImage">
            <!-- <img class="FightersAgreement" src="@/assets/FightersAgreement.png" alt="承诺书"> -->
            &emsp;&emsp;本人自愿参加<u>{{ schoolName }}</u>组织开展的<u>{{ epithet }}</u>自学考试综合评价学习，已认真研读并严格遵守四川省高等教育自学考试综合评价相关管理规定，现就诚信学习郑重承诺如下:<br/>
            &emsp;&emsp;1.本人自愿参加综合评价课程学习，所提供的报名资料真实合法有效。<br/>
            &emsp;&emsp;2.在参加线上学习任务时，配合助学管理平台通过人脸识别等技术手段进行身份确认和考勤登记工作。<br/>
            &emsp;&emsp;3.独立完成知识点练习、阶段作业和综合测评，不违纪舞弊。<br/>
            &emsp;&emsp;4.本人已知晓:所取得的自学考试综合评价成绩经省教育考试院审核通过后，两年内有效。<br/>
            &emsp;&emsp;5.严格遵守综合评价各项管理规定，若违反承诺，同意取消本人综合评价成绩或参加综合评价资格，一切后果由本人承担。<br/>
          </div>
          <div class="cnr">
            <div class="pledge-sign">
              <span>承诺人：</span>
              <el-link v-if="!pledgeData.signImg" type="primary" @click="handleSign">点击签名</el-link>
              <img
                v-if="pledgeData.signImg"
                :src="pledgeData.signImg"
                alt="签名预览"
                class="sign-thumb"
                @click="handleSign"
              />
            </div>
            <div>准考证号：{{ user.certiNo }}</div>
          </div>
          <div class="cnr">
            <div>身份证号：{{ user.idCardNumber }}</div>
          </div>
          <div class="pledge-date">
            <span>{{ displayYear }}</span><span>年</span>
            <span>{{ displayMonth }}</span><span>月</span>
            <span>{{ displayDay }}</span><span>日</span>
          </div>
        </div>
      </div>

      <div class="pledge-actions">
        <el-button @click="handleClose(true)">返回</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </div>

    <el-dialog
      title="扫码签名"
      :visible.sync="signDialogVisible"
      width="520px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :z-index="4100"
      append-to-body
      @close="handleCloseSignDialog"
    >
      <div class="sign-dialog">
        <div class="sign-history" v-if="historySign">
          <div class="label">历史签名：</div>
          <div class="history-box">
            <img :src="historySign" alt="历史签名" />
            <!-- <div v-else class="history-empty">暂无历史签名</div> -->
          </div>
          <el-button type="primary" size="mini" @click="handleUseHistory">
            使用此签名
          </el-button>
        </div>
        <div class="sign-qrcode">
          <div class="label">{{ historySign ? '重新签名' : '签名' }}：</div>
          <div class="qr-box">
            <vue-qr :text="qrUrl" :margin="0" :size="200" />
          </div>
          <el-button type="primary" size="mini" @click="handleConfirmSign">完成签名</el-button>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import vueQr from "vue-qr";
import { mapState } from "vuex"

export default {
  name: "FightersAgreementDialog",
  components: {
    vueQr,
  },
  data() {
    return {
      visible: false,
      pledgeData: {
        cnTitle: "",
        enTitle: "",
        stuName: "",
        stuNo: "",
        admissionNo: "",
        major: "",
        className: "",
        date: new Date(),
        thesisBatchId: "",
        signImg: "",
        historySign: "",
      },
      // 签名弹框
      signDialogVisible: false,
      qrUrl: "",
      historySign: "",
      selectedSign: "",
      schoolName: "",
      epithet: "",
      examConfigId: null
    };
  },
  computed: {
    ...mapState(['tenantInfo', 'schoolInfo', 'user']),
    dateObj() {
      return this.pledgeData.date ? new Date(this.pledgeData.date) : new Date();
    },
    displayYear() {
      return this.dateObj.getFullYear();
    },
    displayMonth() {
      return this.dateObj.getMonth() + 1;
    },
    displayDay() {
      return this.dateObj.getDate();
    },
  },
  methods: {
    open(examConfigId) {
      this.examConfigId = examConfigId;
      this.$http.get('/student/pc/getExamConfig?examConfigId=' + this.examConfigId, {}).then((res) => {
        this.schoolName = res.schoolName;
        this.epithet = res.epithet;
      })

      const baseData = {
        cnTitle: "",
        enTitle: "",
        stuName: "",
        stuNo: "",
        admissionNo: "",
        major: "",
        className: "",
        thesisBatchId: "",
        signImg: "",
        historySign: "",
        date: new Date(),
      };
      this.pledgeData = {
        ...baseData,
      };
      this.historySign = this.pledgeData.historySign || this.pledgeData.signImg || "";
      this.selectedSign = this.historySign;
      this.visible = true;
    },
    handleSubmit() {
      if (!this.pledgeData.signImg) {
        this.$message.error('请先完成签名')
        return
      }

      // 根据签名类型处理不同的提交逻辑
      const signType = this.pledgeData.signType || "pledge";

      if (signType === "taskbook") {
        // 任务书签名：不提交承诺书，只触发确认事件，让父组件处理
        this.$emit("confirm", this.pledgeData);
        this.handleClose(true);
        return;
      }

      // 承诺书签名：提交到后端
      const params = {
        examConfigId: this.examConfigId,
        promiseUrl: this.pledgeData.signImg,
      }
      this.$http.post('/student/pc/study/promise/record', params).then((res) => {
        // this.$message({
        //   showClose: true,
        //   message: "承诺书签名提交成功！",
        //   type: "success",
        // });
        this.handleClose(false);
        this.$emit("confirm", this.pledgeData);
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message || "提交失败，请重试",
          type: "error",
        });
      });
    },
    handleSign() {
      this.buildSignDialog();
      this.signDialogVisible = true;
      this.$http.get('/student/signature/my/history').then((res) => {
        if (res && res.length > 0) {
          this.historySign = res[0].signatureImg
        }

      }).catch(() => {
      });
    },
    buildSignDialog() {
      const user = (this.$store && this.$store.state && this.$store.state.user) || {};
      const params = new URLSearchParams();
      const userId = user.userId || user.id || user.uid || "";
      if (userId) params.append("userId", userId);
      if (this.pledgeData.thesisBatchId) params.append("thesisBatchId", this.pledgeData.thesisBatchId);
      params.append("type", "thesisPledge");
      // const base = `${location.origin}${location.pathname}#/sign`;
      const base = `${location.origin}/student-sign`;
      this.qrUrl = `${base}?${params.toString()}`;

    },
    handleUseHistory() {
      this.pledgeData.signImg = this.historySign
      // this.$emit("sign-selected", this.pledgeData.signImg);
      this.signDialogVisible = false;
    },
    handleConfirmSign() {
      this.$http.get('/student/signature/my/history').then((res) => {
        if (res && res.length > 0) {
          this.pledgeData.signImg = res[0].signatureImg
          // this.$emit("sign-selected", this.pledgeData.signImg);
          this.signDialogVisible = false;
        } else {
          this.$message.error('未获取到个人签名')
          return
        }

      }).catch(() => {
        // alert('提交失败');
      });
      return

      this.pledgeData.signImg = this.selectedSign || this.historySign;
      this.$emit("sign-selected", this.pledgeData.signImg);
      this.signDialogVisible = false;
    },
    handleCloseSignDialog() {
      this.signDialogVisible = false;
    },
    handleClose(boo) {
      this.visible = false;
      if(boo){
        this.$router.push({ path: '/main/home' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pledge-dialog ::v-deep .el-dialog__header {
  display: none;
}
.pledge-container {
  padding: 10px 16px 6px;
  color: #222;
}
.pledge-title {
  text-align: center;
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 1px;
  margin-bottom: 10px;
}
.pledge-sheet {
  // border: 1px solid #333;
  // padding: 12px;
  // box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.pledge-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 14px;
  font-size: 14px;
}
.pledge-table th,
.pledge-table td {
  border: 1px solid #333;
  padding: 10px 12px;
  text-align: left;
}
.pledge-table th {
  width: 120px;
  background: #f8f8f8;
}
.pledge-body {
  // border: 1px solid #333;
  padding: 18px 16px 12px;
}
.pledge-body__title {
  text-align: center;
  font-weight: 700;
  font-size: 26px;
  margin-bottom: 10px;
}
.pledge-body p {
  line-height: 1.8;
  text-indent: 2em;
  margin-bottom: 18px;
}
.promiseImage {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
}
.pledge-sign {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  // justify-content: center;
  width: 300px;
  .sign-thumb {
    height: 40px;
    margin-left: 12px;
    // border: 1px solid #eee;
    padding: 4px;
    // background: #fff;
    cursor: pointer;
  }
}
.pledge-date {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}
.sign-dialog {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.sign-history,
.sign-qrcode {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.label {
  font-weight: 600;
  align-self: flex-start;
}
.history-box,
.qr-box {
  border: 1px solid #e5e5e5;
  padding: 10px;
  min-height: 120px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
}
.history-box img {
  max-width: 100%;
  max-height: 120px;
}
.history-empty {
  color: #999;
}
.pledge-actions {
  text-align: center;
  margin-top: 16px;
}
.FightersAgreement{
  width: 90%;
}
.cnr{
  padding: 40px 40px 0px 40px;
  display: flex;
}
</style>

